export const constants = { dias_adelante_seleccion: 1 };
